module.exports = __webpack_public_path__ + "img/TheUnitedStates.d51fb444.png";